/**
 * Returns the vendor display name
 * - name = "iManage" & tool = "iManage" => iManage
 * - name = "iManage" & tool = null => iManage
 * - name = null & tool = "iManage" => iManage
 * - name = "iManage" & tool = "Browser" => Browser by iManage
 */
export const getVendorDisplayName = (name: string, tool?: string | null, withBy = true): string => {
  // const { tool, name } = vendor
  return tool && name && tool !== name ? (withBy ? `${tool} by ${name}` : `${tool} - ${name}`) : tool || name
}
